export default "__VITE_ASSET__5643955d__"